import { chakra } from '@chakra-ui/react';
import { type ReactNode } from 'react';

const Root = chakra('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'full',
    minWidth: 0,
    bg: 'surface.subtle',
    px: '4',
    py: '10',
  },
});

const Column = chakra('div', {
  base: { width: 'full', minWidth: 0, mx: 'auto' },
});

export interface AuthLayoutProps {
  /** The centered content (a header + card, or a status card). */
  children: ReactNode;
  /** Max width of the centered column. */
  maxWidth?: string;
  /** Min height of the canvas — full viewport for the primary auth screens, less for
   *  the brief OAuth "finishing…" callbacks. */
  minHeight?: string;
}

/**
 * The public / auth canvas (§14). A calm, brand-adjacent recessed surface that centers a
 * single width-capped column vertically and horizontally. Used by the landing, sign-in /
 * register and the OAuth callback status pages — the brand moments that sit OUTSIDE the
 * authenticated console shell.
 */
export function AuthLayout({ children, maxWidth = '26rem', minHeight = '100vh' }: AuthLayoutProps) {
  return (
    <Root minH={minHeight}>
      <Column maxW={maxWidth}>{children}</Column>
    </Root>
  );
}
